var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1522_20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.362305 7.5C1.63893 3.18693 6.14147 0 11.5 0C16.8585 0 21.3611 3.18693 22.6377 7.5C21.3611 11.8131 16.8585 15 11.5 15C6.14147 15 1.63893 11.8131 0.362305 7.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.362305 7.5L-0.596573 7.21618L-0.680581 7.5L-0.596573 7.78382L0.362305 7.5ZM22.6377 7.5L23.5966 7.78382L23.6806 7.5L23.5966 7.21618L22.6377 7.5ZM1.32118 7.78382C2.45277 3.96075 6.51245 1 11.5 1V-1C5.77048 -1 0.825085 2.41312 -0.596573 7.21618L1.32118 7.78382ZM11.5 1C16.4876 1 20.5472 3.96075 21.6788 7.78382L23.5966 7.21618C22.1749 2.41312 17.2295 -1 11.5 -1V1ZM21.6788 7.21618C20.5472 11.0393 16.4876 14 11.5 14V16C17.2295 16 22.1749 12.5869 23.5966 7.78382L21.6788 7.21618ZM11.5 14C6.51245 14 2.45277 11.0393 1.32118 7.21618L-0.596573 7.78382C0.825085 12.5869 5.77048 16 11.5 16V14Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1522_20)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.5C12.75 8.79758 11.9173 9.75 11 9.75C10.0827 9.75 9.25 8.79758 9.25 7.5C9.25 6.20242 10.0827 5.25 11 5.25C11.9173 5.25 12.75 6.20242 12.75 7.5Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.582e0d34267579421992b63b8b5c3da9.svg";
export { ForwardRef as ReactComponent };